import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Cookies = lazy(() => import("@/pages/info/Cookies"));

export const Route = createFileRoute("/cookies")({
  head: () => seoHead("/cookies", { description: "Här förklarar vi vilka cookies och liknande tekniker vi använder på Elmarknad.se, varför vi gör det och hur du styr dina inställningar." }),
  component: () => <Cookies />,
});
